import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { OPERATIONAL_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';
import { useMetricsContext } from '../context/metrics';
import { FORGE_UI_ANALYTICS_CHANNEL } from '.';

// For extensibility

var fireEvent = function fireEvent(createAnalyticsEvent, _ref) {
  var action = _ref.action,
    actionSubject = _ref.actionSubject,
    source = _ref.source,
    attributes = _ref.attributes;
  return createAnalyticsEvent({
    eventType: OPERATIONAL_EVENT_TYPE,
    data: {
      action: action,
      actionSubject: actionSubject,
      attributes: _objectSpread({
        method: 'invoke'
      }, attributes),
      source: source,
      tags: ['forge']
    }
  }).fire(FORGE_UI_ANALYTICS_CHANNEL);
};
var _trackBridgeSucceed = function trackBridgeSucceed(createAnalyticsEvent, _ref2) {
  var source = _ref2.source;
  return fireEvent(createAnalyticsEvent, {
    action: 'succeeded',
    actionSubject: 'forge.ui.bridge',
    source: source
  });
};
export { _trackBridgeSucceed as trackBridgeSucceed };
var _trackBridgeFailed = function trackBridgeFailed(createAnalyticsEvent, _ref3) {
  var source = _ref3.source,
    errorName = _ref3.errorName;
  return fireEvent(createAnalyticsEvent, {
    action: 'failed',
    actionSubject: 'forge.ui.bridge',
    source: source,
    attributes: {
      error: errorName
    }
  });
};
export { _trackBridgeFailed as trackBridgeFailed };
var _trackComponentUsageRendered = function trackComponentUsageRendered(createAnalyticsEvent, _ref4) {
  var source = _ref4.source,
    isLegacyUiKit = _ref4.isLegacyUiKit,
    forgeEnvironment = _ref4.forgeEnvironment,
    components = _ref4.components,
    forgeReactMajorVersion = _ref4.forgeReactMajorVersion;
  return fireEvent(createAnalyticsEvent, {
    action: 'rendered',
    actionSubject: 'forge.ui.analytics.component_usage',
    source: source,
    attributes: {
      appType: "UIKit".concat(isLegacyUiKit ? '1' : ''),
      forgeEnvironment: forgeEnvironment,
      components: components,
      forgeReactMajorVersion: forgeReactMajorVersion
    }
  });
};
export { _trackComponentUsageRendered as trackComponentUsageRendered };
var _trackExtensionLoaded = function trackExtensionLoaded(createAnalyticsEvent, _ref5) {
  var source = _ref5.source,
    forgeEnvironment = _ref5.forgeEnvironment,
    renderType = _ref5.renderType;
  return fireEvent(createAnalyticsEvent, {
    action: 'loaded',
    actionSubject: 'forge.ui.extension',
    source: source,
    attributes: {
      forgeEnvironment: forgeEnvironment,
      renderType: renderType
    }
  });
};
export { _trackExtensionLoaded as trackExtensionLoaded };
export var useForgeUiAnalyticsEvent = function useForgeUiAnalyticsEvent() {
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var _useMetricsContext = useMetricsContext(),
    source = _useMetricsContext.page;
  return {
    trackComponentUsageRendered: function trackComponentUsageRendered(_ref6) {
      var isLegacyUiKit = _ref6.isLegacyUiKit,
        forgeEnvironment = _ref6.forgeEnvironment,
        components = _ref6.components,
        forgeReactMajorVersion = _ref6.forgeReactMajorVersion;
      return _trackComponentUsageRendered(createAnalyticsEvent, {
        source: source,
        isLegacyUiKit: isLegacyUiKit,
        forgeEnvironment: forgeEnvironment,
        components: components,
        forgeReactMajorVersion: forgeReactMajorVersion
      });
    },
    trackExtensionLoaded: function trackExtensionLoaded(_ref7) {
      var forgeEnvironment = _ref7.forgeEnvironment,
        renderType = _ref7.renderType;
      return _trackExtensionLoaded(createAnalyticsEvent, {
        source: source,
        forgeEnvironment: forgeEnvironment,
        renderType: renderType
      });
    },
    trackBridgeSucceed: function trackBridgeSucceed() {
      return _trackBridgeSucceed(createAnalyticsEvent, {
        source: source
      });
    },
    trackBridgeFailed: function trackBridgeFailed(_ref8) {
      var errorName = _ref8.errorName;
      return _trackBridgeFailed(createAnalyticsEvent, {
        source: source,
        errorName: errorName
      });
    }
  };
};